import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {UploadChangeParam} from 'ng-zorro-antd/upload';
import {ToastrService} from 'ngx-toastr';
import {Message} from 'src/app/core/class/message';
import FileUtils, {ContentType} from 'src/app/core/services/file-utils';
import {VerifyDocumentService} from 'src/app/core/services/verify-document.service';
import {BaseComponent} from '../../shared/components/base/base.component';
import {CommonService} from '../../core/services/common.service';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {NotificationService} from 'src/app/core/services/notification.service';
import {pdfDefaultOptions} from 'ngx-extended-pdf-viewer';
import {DeviceDetectorService} from 'ngx-device-detector';

const FileUploadType = 1;

@Component({
  selector: 'app-verify-document',
  templateUrl: './verify-document.component.html',
  styleUrls: ['./verify-document.component.scss']
})
export class VerifyDocumentComponent extends BaseComponent implements OnInit {
  public language: string;
  public isShowSidebarButton = true;

  constructor(
    private toastr: ToastrService,
    private router: Router,
    public message: Message,
    private verifyDocumentService: VerifyDocumentService,
    public commonService: CommonService,
    private translate: TranslateService,
    private notificationService: NotificationService,
    public deviceService: DeviceDetectorService
  ) {
    super(commonService, message);
    this.language = localStorage.getItem('__language') || 'vi';
    pdfDefaultOptions.renderInteractiveForms = false;
    console.log(this.deviceService.getDeviceInfo().deviceType);
    if (!this.deviceService.isDesktop()) {
      this.isShowSidebarButton = false;
      this.zoomLevel = 50;
    }
  }

  @ViewChild('fileDropRef', {static: false}) fileDropEl: ElementRef;
  @ViewChild('inputUpload', {static: false}) inputUpload: ElementRef;
  @ViewChild('dirDragAndDrop', {static: false}) dirDragAndDrop: ElementRef;
  files: any[] = [];
  isShowPDFViewer = false;
  isHasResponse = false;
  fileUpload: File;
  isDisable = true;
  pdfSrc: string;
  isDragging = false;
  isSignOnSContract = false;
  isValid = false;
  signatureInfo = {
    isSignOnSContract: false,
    isValid: false,
    listInfo: []
  };
  document: { id: number };
  panelDocumentComponent: {
    valueSelect: number,
    pdfSrc: string
  };
  listInfo: any;
  public flagCopy: boolean;
  isFormChanging: boolean;
  zoomLevel = 100;
  background = '#f5fcff';

  ngOnInit() {
    // (window as any).pdfWorkerSrc = '/assets/js/pdf.worker.js';
    this.panelDocumentComponent = {
      ...this.panelDocumentComponent,
      valueSelect: 1,
      pdfSrc: ''
    };
    window.scrollTo(0, 0);
    this.commonService.getCurrentLanguage().subscribe(lang => {
      if (lang !== this.language) {
        location.reload();
      }
    });
  }

  onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#9ecbec';
  }

  onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#f5fcff';
  }

  ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.isDragging = false;
    this.background = '#f5fcff';
    this.onSelectedUpload(evt, true);
  }

  onSelectedUpload(Event, isDrop = false) {
    if (this.panelDocumentComponent.valueSelect !== FileUploadType) {
      this.panelDocumentComponent.valueSelect = FileUploadType;
      this.panelDocumentComponent.pdfSrc = '';
    }
    this.pdfSrc = '';
    this.resetInput();
    this.getFile(Event, isDrop);
  }

  resetInput() {
    this.isHasResponse = false;
    this.signatureInfo = {
      isSignOnSContract: false,
      isValid: false,
      listInfo: []
    };
  }

  public getFile(e, isDrop = false) {
    if (typeof (FileReader) !== 'undefined') {
      let file: File;
      if (isDrop) {
        file = e.dataTransfer.files[0];

      } else {
        file = e.target.files[0];

      }

      if (file.type !== 'application/pdf') {
        if (!this.toastr.findDuplicate(this.message.getMessage('messages.only_accept_pdf'), true, true)) {
          this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
          this.isDisable = true;
          this.isShowPDFViewer = false;
        }
      } else {
        if (file.size <= 10485760) {
          this.checkContentTypeThenAddFile(file);
        } else {
          if (!this.toastr.findDuplicate(this.message.getMessage('validation.file'), true, true)) {
            this.toastr.error(this.message.getMessage('validation.file'));
            this.isDisable = true;
            this.isShowPDFViewer = false;

          }
        }
      }
      // this.reset();
    }
    // this.isHasResponse = true;
    if (this.fileDropEl) {
      this.fileDropEl.nativeElement.value = '';
    }
    if (this.inputUpload) {
      this.inputUpload.nativeElement.value = '';
    }
  }

  private checkContentTypeThenAddFile(file: File) {
    FileUtils.getContentType(file)
      // tslint:disable-next-line:no-shadowed-variable
      .then((ct) => {
        if (ContentType.PDF === ct) {
          this.fileUpload = file;
          const reader = new FileReader();
          // tslint:disable-next-line:no-shadowed-variable
          reader.onload = (e: any) => {
            this.pdfSrc = e.target.result;
            this.isShowPDFViewer = true;
            this.isDisable = false;
          };
          reader.readAsArrayBuffer(file);
          this.setFormChanging(true);
        } else {
          this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
          this.isDisable = true;
          this.isShowPDFViewer = false;

        }
      }).catch((err) => {
      this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
      this.isDisable = true;
      this.isShowPDFViewer = false;

    });
  }

  setFormChanging(changingStatus: boolean): void {
    this.isFormChanging = changingStatus;
    // this.hasChange.emit(changingStatus);
  }

  onClickBtnCancel() {

  }

  onClickBtnSave() {
    this.verifyDocumentService.documentVerify(this.fileUpload).subscribe(res => {
      const {data} = res;
      this.isSignOnSContract = data.isOnScontract;
      this.isValid = data.isValid;
      this.listInfo = data.listInfo;
      this.signatureInfo = data;
      this.isHasResponse = true;
      this.isDisable = true;
    }, (error => {
      this.toastr.error(this.message.getMessage('messages.error_message'));
    }));
  }

  onPanelChange($event: boolean) {

  }

  handleChange({file, fileList}: UploadChangeParam): void {
    const status = file.status;
    if (status !== 'uploading') {
      // console.log(file, fileList);
    }
    if (status === 'done') {
      // this.msg.success(`${file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      // this.msg.error(`${file.name} file upload failed.`);
    }
  }

  login() {
    this.router.navigate(['enterprise-login']);
  }

  onChangeLanguage(languageSelected: string) {
    this.setLanguagelocalStored(languageSelected);
    this.translate.use(this.getLanguagelocalStored());
    this.checkIconLanguage(this.getLanguagelocalStored());
  }

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  onBackClick() {
    this.router.navigate(['/']);
  }
}
